// 무료 폰트 상세의 "다운로드 페이지로 이동" 클릭을 기록한다(FontOutboundClick).
//
// 사용 예시:
//   <a href="<%= with_noonnu_ref(@font.d_link) %>" target="_blank"
//      data-controller="fonts--outbound-click"
//      data-fonts--outbound-click-url-value="<%= visit_public_font_path(@font) %>"
//      data-action="click->fonts--outbound-click#report auxclick->fonts--outbound-click#report">
//
// - 링크 주소는 바꾸지 않는다. 클릭 순간 비콘만 따로 보내므로 이동이 늦어지지 않는다.
// - 가운데 클릭(새 탭)도 auxclick 으로 센다. 오른쪽 클릭은 메뉴만 연 것이라 세지 않는다.
// - 같은 페이지에서는 한 번만 보낸다(여러 번 눌러도 한 사람의 한 번 이동).
import { Controller } from "@hotwired/stimulus";
import api from "@/utils/api";

export default class extends Controller {
  static values = { url: String };

  connect() {
    this.reported = false;
  }

  report(event) {
    if (event.type === "auxclick" && event.button !== 1) return;
    if (this.reported || !this.urlValue) return;
    this.reported = true;

    // 새 탭으로 열려도 지금 페이지가 떠날 수 있으니 이탈 중에도 전송되는 sendBeacon 을 먼저 쓴다.
    if (navigator.sendBeacon && navigator.sendBeacon(this.urlValue)) return;
    api.post(this.urlValue).catch(() => {
      // 기록 실패는 무시한다
    });
  }
}
